import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const NextArrowIcon = ({ onClick })=>/*#__PURE__*/ _jsxs("svg", {
        onClick: onClick,
        width: "57",
        height: "57",
        viewBox: "0 0 57 57",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "28.5",
                cy: "28.5",
                r: "28",
                transform: "matrix(-1 0 0 1 57 0)",
                fill: "white",
                stroke: "#DCDFEC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M42.2071 29.2071C42.5976 28.8166 42.5976 28.1834 42.2071 27.7929L35.8431 21.4289C35.4526 21.0384 34.8195 21.0384 34.4289 21.4289C34.0384 21.8195 34.0384 22.4526 34.4289 22.8431L40.0858 28.5L34.4289 34.1569C34.0384 34.5474 34.0384 35.1805 34.4289 35.5711C34.8195 35.9616 35.4526 35.9616 35.8431 35.5711L42.2071 29.2071ZM15.5 29.5H41.5V27.5H15.5V29.5Z",
                fill: "black"
            })
        ]
    });
